import BasicInfoHOC from './BasicInfoHOC'
export default BasicInfoHOC


// WEBPACK FOOTER //
// ./src/modules/BasicInfoHOC/index.js